import { THEMES_REUSE_ACTION as ACTION_TYPE } from '../types/actionTypes';
const setSuggestedThemes = dispatch => themes => dispatch({
  type: ACTION_TYPE.SET_SUGGESTED_THEMES,
  payload: {
    suggestedThemes: themes
  }
});
const setSuggestedThemesForResponse = dispatch => (suggested, responseTextId) => dispatch({
  type: ACTION_TYPE.SET_SUGGESTED_THEMES_FOR_RESPONSE,
  payload: {
    suggested,
    responseTextId
  }
});
const setUseCases = dispatch => useCases => dispatch({
  type: ACTION_TYPE.SET_USE_CASES,
  payload: {
    useCases
  }
});
const setPreviouslyUsedThemes = dispatch => previouslyUsedThemes => dispatch({
  type: ACTION_TYPE.SET_PREVIOUSLY_USED_THEMES,
  payload: {
    previouslyUsedThemes
  }
});
const setSelectedUseCase = dispatch => selectedUseCase => dispatch({
  type: ACTION_TYPE.SET_SELECTED_USE_CASE,
  payload: {
    selectedUseCase
  }
});
const setSelectedReusedThemes = dispatch => selectedReusedThemes => dispatch({
  type: ACTION_TYPE.SET_SELECTED_REUSED_THEMES,
  payload: {
    selectedReusedThemes
  }
});
const addReusedTheme = dispatch => reusedTheme => dispatch({
  type: ACTION_TYPE.ADD_REUSED_THEME,
  payload: {
    reusedTheme
  }
});
const removeReusedTheme = dispatch => reusedTheme => dispatch({
  type: ACTION_TYPE.REMOVE_REUSED_THEME,
  payload: {
    reusedTheme
  }
});
const addPreviouslyUsedTheme = dispatch => previouslyUsedTheme => dispatch({
  type: ACTION_TYPE.ADD_PREVIOUSLY_USED_THEME,
  payload: {
    previouslyUsedTheme
  }
});
const removePreviouslyUsedTheme = dispatch => previouslyUsedTheme => dispatch({
  type: ACTION_TYPE.REMOVE_PREVIOUSLY_USED_THEME,
  payload: {
    previouslyUsedTheme
  }
});
// sometimes we need to update multiple state values at once
const setMultiple = dispatch => payload => dispatch({
  type: ACTION_TYPE.SET_MULTIPLE,
  payload
});
export default {
  setSuggestedThemes,
  setSuggestedThemesForResponse,
  setPreviouslyUsedThemes,
  setUseCases,
  setSelectedUseCase,
  setSelectedReusedThemes,
  addReusedTheme,
  removeReusedTheme,
  addPreviouslyUsedTheme,
  removePreviouslyUsedTheme,
  setMultiple
};